import React, { useReducer, useMemo, useLayoutEffect, useState } from 'react';
import { connect } from 'formik';
import Context from './Context';
import registrationFieldReducer from './registrationFieldReducer';
import { getSections } from './utils';

// @ts-ignore
function FormTableOfContentsProvider({
  children = null,
  formik,
}: {
  children: React.ReactNode | React.ReactNodeArray | null;
  formik: {
    errors: {};
  };
}) {
  const [fields, dispatchFields] = useReducer(registrationFieldReducer, {});
  const [sectionsTracker, setSectionsTracker] = useState([]);
  const [orderedSections, setOrderedSections] = useState([]);
  function registerSection() {
    // @ts-ignore
    setSectionsTracker((tracker) => tracker + 1);
  }

  function unregisterSection() {
    // @ts-ignore
    setSectionsTracker((tracker) => tracker + 1);
  }

  useLayoutEffect(() => {
    // @ts-ignore
    const result = [];
    document.querySelectorAll('.form-section__title').forEach((item) => {
      // special chars will be converted, so you need to convert them back.
      // So far, we only have & as a special char in the titles;
      result.push(item.innerHTML.replace(/&amp;/g, '&'));
    });
    // @ts-ignore
    setOrderedSections(result);
  }, [sectionsTracker]);

  const sections = useMemo(
    () => getSections(orderedSections, fields, formik.errors),
    [fields, formik.errors, orderedSections],
  );

  // @ts-ignore
  function registerField(field, section) {
    // @ts-ignore
    dispatchFields({ type: 'register', field, section });
  }

  // @ts-ignore
  function unregisterField(field, section) {
    // @ts-ignore
    dispatchFields({ type: 'unregister', field, section });
  }

  return (
    <Context.Provider
      value={{
        fields,
        registerField,
        registerSection,
        // @ts-ignore
        unregisterField,
        unregisterSection,
        // @ts-ignore
        sections,
      }}
    >
      {children}
    </Context.Provider>
  );
}

export default connect(FormTableOfContentsProvider);
